import { FilterKey } from '@services/filters/types';
import { kebabToCamelCase } from '@utils/textHelpers';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { appRoutes } from '@utils/consts';

const KEYS: FilterKey[] = [
  'hotSeat',
  'workload',
  'map',
  'jobs',
  'users',
  'builders',
  'inventory',
  'tenants',
  'admins',
];

export const useFilterKey = () => {
  const { pathname } = useLocation();

  return useMemo(() => {
    if (pathname.includes(appRoutes.onDeck)) return 'hotSeat';
    return KEYS.find((el) => kebabToCamelCase(pathname.replace('panel/', '')).endsWith(el));
  }, [pathname]) as FilterKey;
};
